/**
 *  @function AldwynCrossStoreCheckout
 *  @description
 *  Khi người dùng bấm nút checkout (button[name="checkout"]) trên CỬA HÀNG HIỆN TẠI,
 *  script đọc giỏ hàng, tìm biến thể (variant) tương ứng trên cửa hàng ĐÍCH (aldwynco.com),
 *  rồi chuyển hướng sang cart permalink dạng https://aldwynco.com/cart/ID:QTY,ID:QTY.
 *
 *  Kiến trúc: MATCH TRƯỚC -> REDIRECT SAU. Nếu BẤT KỲ dòng nào không giải quyết được,
 *  HỦY toàn bộ redirect và để checkout gốc chạy bình thường (không redirect một phần).
 *
 *  Cả hai cửa hàng dùng CHUNG theme này, nên script tự phát hiện host lúc chạy và KHÔNG làm gì
 *  khi đang ở chính aldwynco.com (để checkout gốc chạy).
 *
 *  CÁCH NHÚNG (thêm vào cuối layout/theme.liquid, ngay trước </body>, dùng TAB như các dòng khác):
 *    <script src="{{ 'aldwyn-cross-store-checkout.js' | asset_url }}" defer="defer"></script>
 */

(function () {
  'use strict';

  // Chống gắn listener hai lần (nếu file bị nhúng trùng)
  if (window.__aldwynCrossStoreCheckout) return;
  window.__aldwynCrossStoreCheckout = true;

  /* =========================================================================
   * ====  CẤU HÌNH — CHỈNH TAY Ở ĐÂY  =======================================
   * =======================================================================*/

  // Bật log chi tiết ra console (info). Cảnh báo/lỗi luôn được in dù cờ này tắt.
  const DEBUG = false;

  // Tên miền cửa hàng ĐÍCH (nơi cart permalink trỏ tới). Đây là hằng số duy nhất
  // cần đổi nếu domain thay đổi. Không kèm https:// và không kèm dấu / cuối.
  const TARGET_DOMAIN = 'aldwynco.com';

  // Domain .myshopify.com của cửa hàng đích (nếu biết). Dùng để nhận diện chắc chắn
  // hơn khi đang xem qua preview/myshopify. Để trống nếu chưa biết.
  const TARGET_MYSHOPIFY = ''; // ví dụ: 'aldwynco.myshopify.com'

  // Các host được coi là "ĐANG Ở cửa hàng đích" -> script KHÔNG can thiệp, để checkout gốc chạy.
  // Đã tự động bao gồm TARGET_DOMAIN và biến thể www. Thêm domain staging/preview nếu có.
  const EXTRA_TARGET_HOSTS = [
    // 'staging.aldwynco.com',
    // 'aldwynco.myshopify.com',
  ];

  /**
   * ===== DANH SÁCH WEB (DOMAIN NGUỒN) ĐƯỢC PHÉP CHẠY FILE NÀY =====
   * Script CHỈ hoạt động khi web hiện tại nằm trong danh sách này. Ở domain khác -> không làm gì,
   * nút checkout chạy y như bình thường.
   *
   * VD: 'halosneaker.com' -> khớp https://halosneaker.com/products/comfort-orthopedic-shoes,
   *     và khớp cả www.halosneaker.com, shop.halosneaker.com (mọi subdomain).
   *     KHÔNG khớp halosneaker.com.abc.net (tránh domain giả mạo lợi dụng).
   *
   * Chỉ ghi TÊN MIỀN: không kèm https://, không kèm đường dẫn, không kèm dấu / cuối.
   * ĐỂ MẢNG RỖNG [] -> chạy trên MỌI domain (tắt kiểm tra này).
   *
   * LƯU Ý: KHÔNG cần thêm store đích (aldwynco.com) vào đây — nó được xử lý riêng qua TARGET_DOMAIN,
   * và phần "nhận" trên aldwynco vẫn luôn chạy dù danh sách này không có nó.
   */
  const ALLOWED_SOURCE_DOMAINS = [
    // 'halosneaker.com',
    // 'halosneaker.myshopify.com',   // thêm nếu test qua bản xem trước .myshopify.com
    // 'mot-web-khac.com',
  ];

  // Giới hạn thời gian cho mỗi request cross-origin (ms). Quá hạn -> coi như thất bại -> checkout gốc.
  const REQUEST_TIMEOUT_MS = 8000;

  // Thời gian sống của cache catalogue trong sessionStorage (ms).
  const CATALOGUE_TTL_MS = 10 * 60 * 1000; // 10 phút

  // Chặn quét vô hạn: 40 trang * 250 sp = tối đa 10.000 sản phẩm.
  const MAX_CATALOGUE_PAGES = 40;
  const PAGE_DELAY_MS = 200; // nghỉ giữa các trang để tránh bị throttle

  // Nếu true -> permalink có ?storefront=true (về trang GIỎ HÀNG). Mặc định false -> vào thẳng CHECKOUT.
  const GO_TO_CART_INSTEAD = false;

  // Giới hạn độ dài URL permalink (an toàn cho trình duyệt). Vượt ngưỡng -> checkout gốc.
  const MAX_URL_LENGTH = 2000;

  // PHƯƠNG ÁN DỰ PHÒNG (mode B) khi KHÔNG fetch được cross-origin (CORS bị chặn / mạng lỗi):
  // MÃ HÓA giỏ hàng vào URL '/cart?aldwyn_xcart=...' rồi chuyển sang aldwynco để chính script này
  // (chạy trên aldwynco) giải mã và khớp SAME-ORIGIN.
  // ĐẶT false (theo yêu cầu): KHÔNG bao giờ dùng URL aldwyn_xcart nữa. Khi không dựng được permalink
  // thẳng (variant không khớp 100%, HOẶC fetch cross-origin lỗi) -> DÙNG CHECKOUT GỐC của trang hiện
  // tại như bình thường. Chỉ khi khớp trọn vẹn mới sang thẳng https://aldwynco.com/cart/ID:QTY.
  const ENABLE_DATA_REDIRECT_FALLBACK = false;

  // Tên tham số URL mang dữ liệu giỏ hàng sang store đích (phần "nhận" đọc tham số này).
  const INCOMING_PARAM = 'aldwyn_xcart';

  // Trang "hạ cánh" trên store đích cho phương án dự phòng (nên nhẹ; script sẽ tự nhảy tiếp
  // sang /cart/ID:QTY sau khi khớp xong). '/cart' thường nhẹ và đúng ngữ cảnh.
  const RECEIVER_LANDING_PATH = '/cart';

  /* ===== ĐIỀU KIỆN: SẢN PHẨM CHỈ ĐƯỢC MUA 1 CÁI =========================
   * Một số sản phẩm hay lỗi khi mua từ 2 cái trở lên. Với các sản phẩm liệt kê ở đây:
   * TỔNG SỐ LƯỢNG của CHÍNH sản phẩm đó trong giỏ phải ĐÚNG BẰNG 1 thì mới sang aldwynco.
   * Nhiều hơn 1 -> bấm checkout dùng CHECKOUT GỐC của trang hiện tại như thường.
   *
   * VẪN ĐƯỢC mua CHUNG với sản phẩm KHÁC — điều kiện này chỉ giới hạn số lượng của riêng nó.
   * Cộng dồn MỌI BIẾN THỂ (variant) của cùng một sản phẩm:
   *    A/Black 1 cái + A/White 1 cái = 2 cái sản phẩm A  -> LOẠI (checkout gốc)
   *    A/Black 2 cái                 = 2 cái sản phẩm A  -> LOẠI
   *    A/Black 1 cái + sản phẩm B    = 1 cái sản phẩm A  -> ĐẠT (B mua mấy cái cũng được)
   * ========================================================================*/

  // Ghi TIÊU ĐỀ hoặc HANDLE sản phẩm ở CỬA HÀNG HIỆN TẠI (không phân biệt hoa/thường, dấu tiếng Việt,
  // dấu câu — đều được chuẩn hóa khi so khớp, giống PRODUCT_MAP).
  // ĐỂ MẢNG RỖNG [] -> TẮT điều kiện này (mọi sản phẩm mua bao nhiêu cái cũng được).
  const SINGLE_UNIT_PRODUCTS = [
    'Slipclouds Orthopedic Shoes'
    // 'Anti-Choking Emergency Rescue Kit',      // khớp theo tiêu đề
    // 'anti-choking-emergency-rescue-kit',      // hoặc khớp theo handle
  ];

  /* ===== ĐIỀU KIỆN: CHỈ CHẠY TRÊN THIẾT BỊ DI ĐỘNG =======================
   * CHỈ chuyển sang aldwynco khi khách dùng ĐIỆN THOẠI (và máy tính bảng, tùy cấu hình bên dưới).
   * Máy tính để bàn/laptop -> bấm checkout dùng CHECKOUT GỐC của trang hiện tại như thường.
   * ========================================================================*/

  // Bật/tắt điều kiện này. false -> chạy trên MỌI thiết bị (như trước khi thêm điều kiện).
  const MOBILE_ONLY_ENABLED = false;

  // Máy tính bảng (iPad, Android tablet) có được tính là "mobile" không?
  //  true  (mặc định): tablet ĐƯỢC coi là mobile -> vẫn sang aldwynco.
  //  false           : CHỈ ĐIỆN THOẠI mới sang; tablet dùng checkout gốc giống desktop.
  const TREAT_TABLET_AS_MOBILE = false;

  // Ép loại thiết bị để TEST: 'mobile' (giả lập điện thoại) hoặc 'desktop'. Để trống '' khi chạy thật.
  // Bạn đang ngồi máy tính -> đặt 'mobile' để thử luồng redirect. (Chế độ giả lập thiết bị của
  // DevTools — F12 rồi bấm biểu tượng điện thoại — cũng được nhận diện đúng mà không cần sửa dòng này.)
  const DEVICE_TYPE_OVERRIDE = '';

  // CỔNG THỜI GIAN Ở TRÊN TRANG: khách phải Ở TRÊN TRANG HIỆN TẠI đủ số ms này thì mới đủ điều kiện
  // chạy cross-store. Bấm checkout SỚM hơn -> dùng CHECKOUT GỐC như thường.
  // Đếm lại từ đầu MỖI KHI tải/chuyển trang (đo theo trang hiện tại, không cộng dồn cả phiên).
  // 30000 = 30 giây. ĐỂ 0 nếu muốn TẮT điều kiện này.
  const MIN_TIME_ON_PAGE_MS = 0;

  // CỔNG THỜI GIAN: script CHỈ chuyển hướng sang aldwynco khi CHỮ SỐ CUỐI của PHÚT hiện tại
  // nằm trong danh sách này. [0, 5] -> chỉ hoạt động ở các phút ...:00, :05, :10, :15, :20, ...
  // (tức phút chia hết cho 5). Ngoài các phút đó, khách bấm checkout sẽ dùng CHECKOUT GỐC như thường.
  // ĐỂ MẢNG RỖNG [] nếu muốn TẮT cổng thời gian (luôn hoạt động).
  // LƯU Ý: dùng đồng hồ LOCAL của trình duyệt khách; nếu máy khách sai giờ thì cổng cũng sai theo.
  const ACTIVE_MINUTE_LAST_DIGITS = [];

  /* ===== CỔNG KHUNG GIỜ: chỉ chạy cross-store trong các khoảng giờ này ====
   * Chạy SONG SONG (VÀ) với cổng phút ở trên: phải ĐỒNG THỜI đúng khung giờ VÀ đúng đuôi phút thì
   * mới chuyển sang aldwynco. Ngoài khung giờ -> bấm checkout dùng CHECKOUT GỐC như thường.
   * ========================================================================*/

  // Mỗi khoảng ghi dạng [bắt đầu, kết thúc): TÍNH mốc đầu, KHÔNG tính mốc cuối.
  //   [[9, 17]]              -> 9:00 đến 16:59 (dừng đúng lúc 17:00)
  //   [[8, 12], [13, 22]]    -> 8:00-11:59 VÀ 13:00-21:59 (nghỉ khung 12:00-12:59)
  //   [[22, 6]]              -> QUA NỬA ĐÊM: 22:00-23:59 và 00:00-05:59
  //   [['09:30', '17:45']]   -> dùng chuỗi 'HH:MM' khi cần lẻ phút
  //   [[0, 24]]              -> cả ngày
  // ĐỂ MẢNG RỖNG [] -> TẮT cổng khung giờ (chạy mọi giờ).
  // LƯU Ý: khoảng có mốc đầu TRÙNG mốc cuối (vd [9, 9]) là khoảng RỖNG -> không bao giờ khớp.
  // const ACTIVE_HOUR_RANGES = [
  //     ['03:15', '03:30'],
  //     ['03:45', '04:00'],
  //     ['04:15', '04:30'],
  //     ['04:45', '05:00'],
  //     ['05:30', '06:30'],
  //     ['07:30', '08:15'],
  //     ['11:30', '13:30'],
  //     ['17:30', '18:30']
  //   ];
  const ACTIVE_HOUR_RANGES = [
    ['02:15', '02:45'],
    ['03:15', '03:45'],
    ['04:15', '04:45'],
    ['05:15', '06:15'],
    ['07:30', '08:15']
  ];
  // const ACTIVE_HOUR_RANGES = [];

  // Múi giờ dùng để đọc "giờ hiện tại" cho ACTIVE_HOUR_RANGES.
  // ĐỂ TRỐNG '' -> dùng ĐỒNG HỒ MÁY KHÁCH (giống cổng phút): khách ở Mỹ thì 9h là 9h giờ Mỹ.
  // Điền tên múi giờ IANA để CỐ ĐỊNH theo một giờ chuẩn bất kể khách ở đâu:
  //   'Asia/Ho_Chi_Minh' (giờ VN), 'America/New_York', 'America/Los_Angeles', 'UTC'
  // Tên múi giờ sai/trình duyệt không hỗ trợ -> tự lùi về đồng hồ máy khách (không làm hỏng checkout).
  const ACTIVE_HOURS_TIMEZONE = 'Asia/Ho_Chi_Minh';

  /* ===== ĐIỀU KIỆN LỚN NHẤT: CHẶN THEO QUỐC GIA CỦA IP =====================
   * IP thuộc các nước trong BLOCKED_COUNTRIES sẽ KHÔNG chạy cross-store (bấm checkout -> dùng
   * checkout gốc như thường). Đây là điều kiện được KIỂM TRA TRƯỚC mọi điều kiện khác (giờ giấc...).
   * Trình duyệt không tự biết quốc gia của IP nên script hỏi một dịch vụ định vị-theo-IP (có CORS).
   * ========================================================================*/

  // Bật/tắt toàn bộ tính năng chặn theo quốc gia.
  const GEO_BLOCK_ENABLED = true;

  // MÃ QUỐC GIA (ISO-2, viết hoa) bị chặn. VN=Việt Nam, HK=Hồng Kông, SG=Singapore.
  const BLOCKED_COUNTRIES = ['VN', 'HK', 'SG', 'JP', 'CN'];

  // Khi KHÔNG xác định được quốc gia (API lỗi/bị chặn/timeout):
  //  - false (mặc định — AN TOÀN cho điều kiện lớn nhất): KHÔNG chạy cross-store -> checkout gốc.
  //  - true: vẫn chạy cross-store dù chưa biết nước (chấp nhận rủi ro sót IP thuộc nước bị chặn).
  const PROCEED_IF_GEO_UNKNOWN = false;

  // Ép quốc gia để TEST (VD 'US' để giả lập khách NGOÀI vùng chặn; 'VN' để thử bị chặn).
  // Để trống '' khi chạy thật. LƯU Ý: nếu bạn đang ở VN, phải đặt 'US' (hoặc dùng VPN) mới test được redirect.
  const GEO_COUNTRY_OVERRIDE = '';

  // Thời gian chờ tối đa cho mỗi lần hỏi API định vị (ms).
  const GEO_LOOKUP_TIMEOUT_MS = 4000;

  /* ===== ĐIỀU KIỆN: CẤM THEO ĐỊA CHỈ IP CỤ THỂ ===========================
   * Khách có IP nằm trong BLOCKED_IPS sẽ KHÔNG chạy cross-store (bấm checkout -> checkout gốc như
   * thường), GIỐNG hệt như bị chặn theo quốc gia. Kiểm tra CÙNG LÚC với chặn quốc gia và DÙNG CHUNG
   * đúng một lần tra IP (cả ba dịch vụ định vị đều trả kèm trường "ip") -> không gọi thêm API nào.
   * ========================================================================*/

  // DANH SÁCH IP BỊ CẤM. Ghi IP đầy đủ, mỗi IP một chuỗi (IPv4 hoặc IPv6). So khớp CHÍNH XÁC cả địa
  // chỉ (không phải dải/subnet). ĐỂ MẢNG RỖNG [] -> TẮT điều kiện này (không cấm IP nào).
  //   VD IPv4: '203.0.113.7'   VD IPv6: '2001:db8::1'
  // LƯU Ý: đây là blocklist -> chỉ chặn khi biết CHẮC IP khách nằm trong danh sách. Không tra được IP
  // thì để điều kiện quốc gia (fail-closed) quyết định, không tự chặn ở đây.
  const BLOCKED_IPS = [
    // 22 IP (đã bỏ trùng) — trích từ ảnh danh sách IP, tất cả đều thuộc US.
    '45.95.186.236',
    '45.141.12.203',
    '74.81.36.101',
    '74.81.46.162',
    '85.31.54.31',
    '104.161.28.205',
    '104.161.41.208',
    '104.161.63.29',
    '107.178.102.204',
    '147.124.205.240',
    '148.163.80.25',
    '173.0.61.155',
    '173.0.61.170',
    '173.0.61.187',
    '193.42.244.58',
    '193.42.244.88',
    '193.42.247.112',
    '193.56.23.78',
    '194.62.165.110',
    '194.62.165.206',
    '194.62.166.86',
    '216.173.116.252',
    '187.15.91.89'
  ];

  // Ép IP để TEST (giả lập khách có IP cụ thể, VD một IP đang nằm trong BLOCKED_IPS để thử bị chặn).
  // Để trống '' khi chạy thật.
  // MẸO TEST: khi ép IP mà KHÔNG ép quốc gia, script coi như "không rõ quốc gia" -> nếu GEO_BLOCK_ENABLED
  // bật và PROCEED_IF_GEO_UNKNOWN=false thì khách bị chặn bởi ĐK quốc gia (không rõ đang chặn vì IP hay
  // vì quốc gia). Muốn test riêng chặn-theo-IP, đặt luôn GEO_COUNTRY_OVERRIDE='US' (hoặc tắt GEO_BLOCK_ENABLED).
  const GEO_IP_OVERRIDE = '';

  /* ===== ĐIỀU KIỆN: CHẶN THEO TỔNG DOANH SỐ ALDWYN TRONG NGÀY =============
   * Nếu TỔNG đơn ĐÃ THANH TOÁN của aldwynco TÍNH TỪ 0h00 GIỜ VIỆT NAM hôm nay > DAILY_LIMIT_USD
   * thì KHÔNG chạy cross-store nữa (bấm checkout -> checkout gốc). Chạy SONG SONG với các điều kiện
   * khác — mọi điều kiện phải cùng đạt thì mới sang aldwyn.
   *
   * QUAN TRỌNG: JS trong theme KHÔNG tự đọc được đơn hàng (dữ liệu riêng tư, cần token admin — không được
   * nhúng vào file công khai). Con số này phải đến từ ENDPOINT bạn tự deploy (xem file
   * aldwyn-order-total-worker.js ở thư mục gốc dự án). Điền URL endpoint vào ORDER_TOTAL_ENDPOINT.
   * ========================================================================*/
  const DAILY_LIMIT_ENABLED = true;

  // URL endpoint trả JSON dạng {"total": <số tiền>, "orders": <số đơn>}. ĐỂ TRỐNG '' -> TẮT điều kiện.
  const ORDER_TOTAL_ENDPOINT = 'https://raspy-salad-48d3.ntd270799.workers.dev/';

  // (a) NGƯỠNG SỐ TIỀN. Tổng đơn hôm nay > ngưỡng -> KHÔNG chạy cross-store.
  // ĐỂ 0 -> TẮT RIÊNG điều kiện số tiền (vẫn giữ điều kiện số đơn bên dưới).
  // LƯU Ý TIỀN TỆ: con số này theo ĐÚNG tiền tệ của store aldwynco (endpoint đang trả currency GBP),
  // KHÔNG phải USD dù tên biến ghi USD. Đặt ngưỡng theo đúng đồng tiền đó.
  const DAILY_LIMIT_USD = 0;

  // (b) NGƯỠNG SỐ ĐƠN. Số đơn ĐÃ THANH TOÁN hôm nay > ngưỡng -> KHÔNG chạy cross-store.
  // Ví dụ 20 -> tới đơn thứ 21 là dừng chuyển hướng (đơn thứ 20 vẫn được).
  // ĐỂ 0 -> TẮT RIÊNG điều kiện số đơn (vẫn giữ điều kiện số tiền ở trên).
  // Con số lấy từ trường "orders" của endpoint (worker đã trả sẵn, không cần sửa gì bên worker).
  const MAX_DAILY_ORDERS = 4;

  // Không lấy được số (endpoint lỗi/timeout)? true = VẪN chạy (fail-open). false = checkout gốc.
  // Áp dụng cho CẢ số tiền lẫn số đơn.
  const PROCEED_IF_LIMIT_UNKNOWN = true;

  // Cache con số bao lâu (ms). Tổng đơn thay đổi liên tục trong ngày nên để NGẮN. 60000 = 60 giây.
  const ORDER_TOTAL_TTL_MS = 60 * 1000;

  // Thời gian chờ tối đa khi hỏi endpoint (ms).
  const ORDER_TOTAL_TIMEOUT_MS = 4000;

  /**
   * PRODUCT_MAP — ánh xạ THỦ CÔNG sản phẩm cửa hàng hiện tại -> handle trên aldwynco.com.
   * Vì tiêu đề/handle KHÁC nhau giữa hai store, hãy điền tay ở đây cho chắc chắn.
   *
   * Khóa (key): handle HOẶC tiêu đề sản phẩm ở CỬA HÀNG HIỆN TẠI (không phân biệt hoa/thường,
   *             dấu tiếng Việt, dấu câu — đều được chuẩn hóa khi so khớp).
   * Giá trị (value): HANDLE sản phẩm tương ứng trên aldwynco.com.
   *
   * Nếu một sản phẩm KHÔNG có trong map -> tự động dò theo tiêu đề đã chuẩn hóa trong catalogue đích.
   */
  const PRODUCT_MAP = {
    // ---- Ví dụ (đã điền mẫu — hãy thay bằng dữ liệu thật, hoặc xóa đi) ----
    // 'ao-thun-basic': 'basic-tee',           // khớp theo handle store hiện tại
    // 'Áo Thun Basic Nam':  'basic-tee',       // hoặc khớp theo tiêu đề
    // 'giay-sneaker-classic': 'classic-sneaker',
    'anti-choking-emergency-rescue-kit': 'getinhalux-anti-choking-emergency-rescue-kit-1',
    // 'casual-sports-loafers-for-men': 'casual-sports-loafers-for-men-1'
  };

  /**
   * OPTION_NAME_MAP — ánh xạ TÊN option cửa hàng hiện tại -> tên option trên aldwynco.com.
   * Ví dụ store hiện tại gọi "Colour"/"Màu sắc" còn aldwynco gọi "Color".
   */
  const OPTION_NAME_MAP = {
    // 'Colour':   'Color',
    // 'Màu sắc':  'Color',
    // 'Kích cỡ':  'Size',
  };

  /**
   * OPTION_VALUE_MAP — ánh xạ GIÁ TRỊ option (áp dụng cho MỌI option) cửa hàng hiện tại -> aldwynco.com.
   * Ví dụ "Small" -> "S", "Đen" -> "Black".
   */
  const OPTION_VALUE_MAP = {
    // 'Small':  'S',
    // 'Medium': 'M',
    // 'Large':  'L',
    // 'Đen':    'Black',
    // 'Trắng':  'White',
  };

  /* =========================================================================
   * ====  HẾT PHẦN CẤU HÌNH — bên dưới là logic  ============================
   * =======================================================================*/

  const TARGET_BASE = 'https://' + TARGET_DOMAIN;
  const CHECKOUT_SELECTOR = 'button[name="checkout"]';
  const SESSION_KEY = 'aldwyn_catalogue_cache_v1';
  const GEO_SESSION_KEY = 'aldwyn_geo_country_v1';
  const BYPASS_ATTR = 'aldwynBypass'; // dataset key: đánh dấu lần submit "bỏ qua interceptor"

  // Danh sách nước bị chặn đã chuẩn hóa (ISO-2 viết hoa) để so khớp nhanh.
  const NORM_BLOCKED_COUNTRIES = (Array.isArray(BLOCKED_COUNTRIES) ? BLOCKED_COUNTRIES : [])
    .map((c) => String(c).trim().toUpperCase());

  // Chuẩn hóa IP để so khớp: bỏ khoảng trắng, hạ chữ thường (IPv6 có chữ hex), bỏ '[]' bao quanh và
  // ':port' của IPv4. KHÔNG rút gọn/nở dạng IPv6 -> hãy dán IP đúng như dịch vụ định vị hiển thị.
  const normalizeIp = (ip) => {
    if (ip === null || ip === undefined) return '';
    let s = String(ip).trim().toLowerCase();
    if (s.charAt(0) === '[') {                       // dạng '[IPv6]' hoặc '[IPv6]:port'
      const end = s.indexOf(']');
      if (end !== -1) s = s.slice(1, end);
    } else if ((s.match(/:/g) || []).length === 1) { // đúng 1 dấu ':' = IPv4:port -> bỏ port
      s = s.slice(0, s.indexOf(':'));
    }
    if (s.indexOf('::ffff:') === 0 && s.indexOf('.') !== -1) s = s.slice(7); // IPv4-mapped IPv6
    return s;
  };

  // Danh sách IP bị cấm đã chuẩn hóa. Rỗng -> tắt điều kiện chặn theo IP.
  const NORM_BLOCKED_IPS = (Array.isArray(BLOCKED_IPS) ? BLOCKED_IPS : [])
    .map((ip) => normalizeIp(ip)).filter(Boolean);

  // Có bật cấm theo IP cụ thể không? (chỉ bật khi có ít nhất 1 IP trong danh sách)
  const IP_BLOCK_ENABLED = NORM_BLOCKED_IPS.length > 0;

  // Có cần tra IP qua mạng không? Cần nếu chặn theo quốc gia HOẶC cấm theo IP.
  const NETWORK_GATE_ENABLED = GEO_BLOCK_ENABLED || IP_BLOCK_ENABLED;

  // Số lần thử tối đa cho MỖI trang catalogue khi bị throttle (429/430) trước khi bỏ cuộc.
  const MAX_THROTTLE_RETRIES = 3;

  // Cache trong bộ nhớ (sống theo vòng đời trang)
  const productCache = new Map();   // handle -> product | null (kết quả đã xong)
  const productInFlight = new Map();// handle -> Promise (đang bay) — gộp các lần hỏi TRÙNG handle
  let catalogueMemo = null;         // mảng sản phẩm (đã rút gọn) | null
  let cataloguePromise = null;      // single-flight: lần tải catalogue đang bay
  let inFlight = false;             // cờ chống double-click

  // ---- Log ----------------------------------------------------------------
  const log = (level, ...args) => {
    const prefix = '[aldwyn-xstore]';
    if (level === 'error') { console.error(prefix, ...args); return; }
    if (level === 'warn') { console.warn(prefix, ...args); return; }
    if (DEBUG) console.info(prefix, ...args);
  };

  // ---- Tiện ích -----------------------------------------------------------
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // Chuẩn hóa chuỗi để so khớp: thường hóa, bỏ dấu tiếng Việt, bỏ dấu câu, gộp khoảng trắng.
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    return String(str)
      .toLowerCase()
      .replace(/đ/g, 'd')               // 'đ' không tách được bằng NFD -> xử lý riêng
      .normalize('NFD')                 // tách ký tự + dấu
      .replace(/[̀-ͯ]/g, '')  // bỏ dấu (diacritics)
      .replace(/[^a-z0-9]+/g, ' ')      // bỏ dấu câu -> khoảng trắng
      .trim()
      .replace(/\s+/g, ' ');            // gộp nhiều khoảng trắng
  };

  // Dựng bản map với KHÓA đã chuẩn hóa (để tra cứu không phụ thuộc hoa/thường/dấu).
  const buildNormalizedMap = (map) => {
    const out = {};
    for (const key in map) {
      if (Object.prototype.hasOwnProperty.call(map, key)) {
        out[normalize(key)] = map[key];
      }
    }
    return out;
  };

  const NORM_PRODUCT_MAP = buildNormalizedMap(PRODUCT_MAP);
  const NORM_OPTION_NAME_MAP = buildNormalizedMap(OPTION_NAME_MAP);
  const NORM_OPTION_VALUE_MAP = buildNormalizedMap(OPTION_VALUE_MAP);

  // Áp map tên/giá trị option (trả về giá trị đích thô; caller sẽ normalize khi so khớp).
  const applyNameMap = (name) => {
    const mapped = NORM_OPTION_NAME_MAP[normalize(name)];
    return mapped !== undefined ? mapped : name;
  };
  const applyValueMap = (value) => {
    const mapped = NORM_OPTION_VALUE_MAP[normalize(value)];
    return mapped !== undefined ? mapped : value;
  };

  // ---- Nhận diện cửa hàng -------------------------------------------------
  // Trả về true nếu ĐANG CHẠY trên chính cửa hàng đích -> khi đó KHÔNG can thiệp.
  const isTargetStore = () => {
    const host = (location.hostname || '').toLowerCase().replace(/^www\./, '');
    if (host === TARGET_DOMAIN) return true;
    if (TARGET_MYSHOPIFY && host === TARGET_MYSHOPIFY.toLowerCase()) return true;

    // Shopify.shop (permanent domain) được Shopify tiêm vào runtime qua content_for_header.
    try {
      if (TARGET_MYSHOPIFY && window.Shopify && Shopify.shop &&
        String(Shopify.shop).toLowerCase() === TARGET_MYSHOPIFY.toLowerCase()) {
        return true;
      }
    } catch (e) { /* bỏ qua */ }

    for (let i = 0; i < EXTRA_TARGET_HOSTS.length; i++) {
      const h = String(EXTRA_TARGET_HOSTS[i]).toLowerCase().replace(/^www\./, '');
      if (host === h) return true;
    }
    return false;
  };

  // true nếu web HIỆN TẠI nằm trong danh sách domain nguồn được phép chạy script.
  // Khớp CHÍNH XÁC domain hoặc là SUBDOMAIN của nó:
  //   'halosneaker.com' -> khớp halosneaker.com, www.halosneaker.com, shop.halosneaker.com
  //                     -> KHÔNG khớp halosneaker.com.abc.net (dùng endsWith('.' + domain), không
  //                        dùng "chứa chuỗi", để domain giả mạo không lọt).
  // Mảng rỗng -> cho phép mọi domain (tắt kiểm tra).
  const isAllowedSourceHost = () => {
    if (!Array.isArray(ALLOWED_SOURCE_DOMAINS) || ALLOWED_SOURCE_DOMAINS.length === 0) return true;
    const host = (location.hostname || '').toLowerCase();
    for (let i = 0; i < ALLOWED_SOURCE_DOMAINS.length; i++) {
      // Bỏ 'www.' ở cấu hình để viết 'www.halosneaker.com' hay 'halosneaker.com' đều được.
      const d = String(ALLOWED_SOURCE_DOMAINS[i]).trim().toLowerCase().replace(/^www\./, '');
      if (!d) continue;
      if (host === d || host.endsWith('.' + d)) return true;
    }
    return false;
  };

  // ---- fetch có timeout (bao trùm CẢ lúc đọc body) ------------------------
  // Timer sống xuyên suốt cả việc đọc body (res.json()), nên một response đã gửi
  // xong header nhưng TREO giữa chừng body cũng bị abort -> reject -> về checkout gốc.
  // Trả về { status, ok, headers, data } — data là JSON đã phân tích (chỉ khi ok).
  const fetchWithTimeout = async (url, options) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
    try {
      const res = await fetch(url, Object.assign({ signal: controller.signal }, options || {}));
      const data = res.ok ? await res.json() : null; // đọc body TRONG phạm vi còn timer
      return { status: res.status, ok: res.ok, headers: res.headers, data: data };
    } finally {
      clearTimeout(timer);
    }
  };

  // ---- Đọc giỏ hàng hiện tại (same-origin -> luôn an toàn CORS) -----------
  // Đi qua fetchWithTimeout để /cart.js treo cũng bị abort -> reject -> về checkout gốc.
  const fetchCurrentCart = async () => {
    const res = await fetchWithTimeout('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('/cart.js -> ' + res.status);
    return res.data;
  };

  // ---- Lấy sản phẩm đích theo handle: /products/HANDLE.json --------------
  // LƯU Ý: dùng .json (public storefront feed, CÓ CORS: Access-Control-Allow-Origin: *)
  // CHỨ KHÔNG dùng .js (Ajax API — không mở CORS cross-origin một cách đáng tin cậy).
  // - 404  -> trả null (không tìm thấy; caller sẽ thử chiến lược khác).
  // - throw (CORS/mạng) -> ném lên trên -> HỦY redirect, dùng checkout gốc (quyết định 4).
  const fetchProductByHandle = (handle) => {
    if (!handle) return Promise.resolve(null);
    if (productCache.has(handle)) return Promise.resolve(productCache.get(handle));
    // Đang có 1 request cho ĐÚNG handle này -> dùng chung (khi giải quyết các dòng SONG SONG,
    // hai dòng cùng sản phẩm sẽ không gọi 2 lần).
    if (productInFlight.has(handle)) return productInFlight.get(handle);

    const p = (async () => {
      const url = TARGET_BASE + '/products/' + encodeURIComponent(handle) + '.json';
      // Có GIỚI HẠN số lần thử lại khi bị throttle (429/430) — hay gặp khi giải quyết nhiều dòng SONG
      // SONG (bắn đồng loạt). Retry (giống pullCatalogue) để KHÔNG rơi về checkout gốc chỉ vì throttle.
      for (let attempts = 1; ; attempts++) {
        const res = await fetchWithTimeout(url, { headers: { Accept: 'application/json' } });

        if (res.status === 429 || res.status === 430) {
          if (attempts >= MAX_THROTTLE_RETRIES) {
            throw new Error('products/' + handle + '.json bị throttle (' + res.status +
              ') sau ' + attempts + ' lần thử');
          }
          const retry = Math.min((Number(res.headers.get('Retry-After')) || 2) * 1000, 3000);
          await delay(retry);
          continue; // thử lại chính handle này (có giới hạn)
        }
        if (res.status === 404) { productCache.set(handle, null); return null; }
        if (!res.ok) throw new Error('products/' + handle + '.json -> ' + res.status);

        const data = res.data;
        const product = data && data.product ? data.product : null;
        productCache.set(handle, product);
        return product;
      }
    })();
    productInFlight.set(handle, p);
    // Xong (thành công HAY lỗi) thì gỡ khỏi danh sách đang-bay: lỗi thì lần sau còn thử lại được.
    const done = () => productInFlight.delete(handle);
    p.then(done, done);
    return p;
  };

  // Rút gọn sản phẩm về đúng các trường cần cho khớp biến thể (tiết kiệm bộ nhớ/sessionStorage).
  const extractOptionNames = (product) => {
    const opts = product && product.options;
    if (!Array.isArray(opts)) return [];
    // product.options có thể là mảng object {name,...} (feed .json) hoặc mảng string.
    return opts.map((o) => (o && typeof o === 'object' ? o.name : o));
  };

  const trimProduct = (p) => ({
    handle: p.handle,
    title: p.title,
    options: extractOptionNames(p),
    variants: (Array.isArray(p.variants) ? p.variants : []).map((v) => ({
      id: v.id,
      option1: v.option1 !== undefined ? v.option1 : null,
      option2: v.option2 !== undefined ? v.option2 : null,
      option3: v.option3 !== undefined ? v.option3 : null,
      available: v.available,
    })),
  });

  // ---- Quét toàn bộ catalogue đích (public feed /products.json, page-until-empty) ----
  const pullCatalogue = async () => {
    const all = [];
    for (let page = 1; page <= MAX_CATALOGUE_PAGES; page++) {
      const url = TARGET_BASE + '/products.json?limit=250&page=' + page;

      // Tải 1 trang, có GIỚI HẠN số lần thử lại khi bị throttle (429/430) để KHÔNG treo checkout.
      let data = null;
      for (let attempts = 1; ; attempts++) {
        const res = await fetchWithTimeout(url, { headers: { Accept: 'application/json' } });

        if (res.status === 429 || res.status === 430) { // bị throttle
          if (attempts >= MAX_THROTTLE_RETRIES) {
            // Hết lượt thử -> NÉM lỗi để .catch() ở interceptor về checkout gốc (không lặp vô hạn).
            throw new Error('products.json page ' + page + ' bị throttle (' + res.status +
              ') sau ' + attempts + ' lần thử');
          }
          // Retry-After KHÔNG phải header CORS-safelisted -> thường null cross-origin (=> 2s).
          // Kẹp trần thời gian chờ để một giá trị lớn cũng không làm treo checkout.
          const retry = Math.min((Number(res.headers.get('Retry-After')) || 2) * 1000, 3000);
          await delay(retry);
          continue; // thử lại CHÍNH trang này (có giới hạn)
        }
        if (!res.ok) throw new Error('products.json page ' + page + ' -> ' + res.status);

        data = res.data;
        break; // tải trang thành công -> thoát vòng thử lại
      }

      const products = data && Array.isArray(data.products) ? data.products : [];
      if (products.length === 0) break;            // mảng rỗng = hết catalogue
      for (let i = 0; i < products.length; i++) all.push(trimProduct(products[i]));
      if (products.length < 250) break;            // trang cuối (chưa đầy)
      await delay(PAGE_DELAY_MS);
    }
    return all;
  };

  // Lấy catalogue với cache: bộ nhớ -> sessionStorage (TTL) -> tải mới.
  // Single-flight: khi giải quyết nhiều dòng SONG SONG, tất cả dùng CHUNG 1 lần tải (không tải trùng).
  const getCatalogue = () => {
    if (catalogueMemo) return Promise.resolve(catalogueMemo);
    if (cataloguePromise) return cataloguePromise;

    cataloguePromise = (async () => {
      try {
        const raw = sessionStorage.getItem(SESSION_KEY);
        if (raw) {
          const parsed = JSON.parse(raw);
          if (parsed && Array.isArray(parsed.products) &&
            (Date.now() - parsed.t) < CATALOGUE_TTL_MS) {
            catalogueMemo = parsed.products;
            log('info', 'Dùng catalogue từ sessionStorage:', catalogueMemo.length, 'sản phẩm');
            return catalogueMemo;
          }
        }
      } catch (e) { /* sessionStorage hỏng/không có -> bỏ qua */ }

      log('info', 'Đang tải catalogue từ', TARGET_BASE);
      const products = await pullCatalogue();
      catalogueMemo = products;
      try {
        sessionStorage.setItem(SESSION_KEY, JSON.stringify({ t: Date.now(), products }));
      } catch (e) { /* vượt quota -> chỉ dùng cache bộ nhớ */ }
      log('info', 'Đã tải catalogue:', products.length, 'sản phẩm');
      return products;
    })();
    // Xong thì bỏ cờ đang-bay: thành công đã có catalogueMemo; lỗi thì lần bấm sau được tải lại.
    const clear = () => { cataloguePromise = null; };
    cataloguePromise.then(clear, clear);
    return cataloguePromise;
  };

  // ---- Khớp biến thể ------------------------------------------------------
  const isAvailable = (variant) => variant && variant.available !== false;

  // Lấy các cặp {name,value} đã chuẩn hóa + đã áp map từ 1 line item của /cart.js.
  const extractCartPairs = (item) => {
    const owv = Array.isArray(item.options_with_values) ? item.options_with_values : [];
    return owv.map((o) => ({
      name: normalize(applyNameMap(o.name)),
      value: normalize(applyValueMap(o.value)),
    }));
  };

  // Sản phẩm chỉ có 1 biến thể ("Default Title") -> không có option để so khớp.
  const isDefaultOnly = (cartPairs) =>
    cartPairs.length === 0 ||
    (cartPairs.length === 1 && cartPairs[0].name === 'title' && cartPairs[0].value === 'default title');

  // Với sản phẩm default-only: chọn biến thể available DUY NHẤT; nếu mơ hồ -> null.
  const pickForDefault = (variants) => {
    if (variants.length === 1) return isAvailable(variants[0]) ? variants[0] : null;
    const avail = variants.filter(isAvailable);
    if (avail.length === 1) return avail[0];
    return null; // nhiều lựa chọn -> không đoán
  };

  // (a) Khớp theo TÊN option: yêu cầu cùng tập tên option và MỌI giá trị trùng.
  // Nếu sản phẩm đích có số option KHÁC -> tập tên khác nhau -> không khớp (an toàn).
  const variantMatchesByName = (variant, targetOptionNames, cartPairs) => {
    const targetMap = {};
    for (let i = 0; i < targetOptionNames.length; i++) {
      const val = variant['option' + (i + 1)];
      if (val === null || val === undefined) continue;
      targetMap[normalize(targetOptionNames[i])] = normalize(val);
    }
    const targetKeys = Object.keys(targetMap);
    if (targetKeys.length !== cartPairs.length) return false;      // khác số option -> bỏ
    return cartPairs.every((pair) => targetMap[pair.name] === pair.value);
  };

  // Trả về biến thể đích khớp + còn hàng, hoặc null (hết hàng / không khớp).
  // GHI CHÚ: /products.json chỉ cho biết boolean `available`, KHÔNG có số tồn kho, nên
  // "số lượng > tồn kho" không thể kiểm tra trước; ta chỉ yêu cầu available !== false,
  // còn checkout mới là nguồn sự thật cuối cùng.
  //
  // CHỈ khớp theo TÊN option (sau khi áp OPTION_NAME_MAP). KHÔNG có fallback theo VỊ TRÍ:
  // hai store có thể khai báo option theo THỨ TỰ khác nhau, nên khớp theo index dễ chọn
  // NHẦM biến thể (vd Left/Right đảo chỗ, kích thước đối xứng). Không căn được theo tên
  // -> trả null để HỦY redirect và dùng checkout gốc (fail-safe), thay vì đoán theo vị trí.
  const matchVariant = (product, item) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    if (variants.length === 0) return null;

    const cartPairs = extractCartPairs(item);
    if (isDefaultOnly(cartPairs)) return pickForDefault(variants);

    const targetOptionNames = extractOptionNames(product);

    const byName = variants.find((v) => variantMatchesByName(v, targetOptionNames, cartPairs));
    if (byName) return isAvailable(byName) ? byName : null;

    return null;
  };

  // ---- Giải quyết 1 line item -> variant id trên cửa hàng đích -----------

  // Những line item KHÔNG thể tái tạo qua cart permalink -> phải HỦY (quyết định 4):
  //  - subscription/selling plan (permalink không mang selling_plan),
  //  - thuộc tính tùy chỉnh do người dùng nhập (engraving/upload/quà tặng...).
  const isPermalinkSafe = (item) => {
    if (item.selling_plan_allocation) {
      log('warn', 'Line item có selling plan (subscription) — không thể mang qua permalink:', item.title);
      return false;
    }
    if (item.properties) {
      const custom = Object.keys(item.properties).filter((k) => k.charAt(0) !== '_');
      if (custom.length > 0) {
        log('warn', 'Line item có thuộc tính tùy chỉnh — không thể mang qua permalink:', item.title, custom);
        return false;
      }
    }
    return true;
  };

  // Thử khớp biến thể trong MỘT sản phẩm. Trả { product, variant } nếu khớp + còn hàng, else null.
  const matchInProduct = (product, item) => {
    const variant = matchVariant(product, item);
    return variant ? { product: product, variant: variant } : null;
  };

  // Giải quyết 1 line item -> variant id trên store đích.
  // Chiến lược (ưu tiên từ trên xuống):
  //  (1) PRODUCT_MAP: đã map tay -> DÙNG ĐÚNG sản phẩm đó (authoritative). Không khớp biến thể -> hủy.
  //  (2) ĐƯỜNG NHANH: đoán theo handle; nếu handle + tiêu đề + BIẾN THỂ đều khớp -> dùng luôn
  //      (khỏi tải cả catalogue). Đây là trường hợp phổ biến nhất.
  //  (3) QUÉT nhiều sản phẩm cùng tiêu đề: khi (2) có sản phẩm nhưng biến thể KHÔNG khớp (rất có thể
  //      sản phẩm đúng là một sản phẩm KHÁC cùng tên, vd aldwynco có 'anti-choking-emergency' VÀ
  //      'anti-choking-emergency-1'), duyệt MỌI sản phẩm cùng tiêu đề trong catalogue và chọn cái
  //      DUY NHẤT có biến thể khớp. 0 khớp -> hủy; >= 2 khớp -> MƠ HỒ -> hủy (tránh mua nhầm).
  const resolveLineItem = async (item) => {
    if (!isPermalinkSafe(item)) return null;

    // (1) PRODUCT_MAP — ưu tiên cao nhất, dùng đúng sản phẩm đã map.
    const mappedHandle = NORM_PRODUCT_MAP[normalize(item.handle)] ||
      NORM_PRODUCT_MAP[normalize(item.product_title)] || null;
    if (mappedHandle) {
      log('info', 'PRODUCT_MAP:', (item.handle || item.product_title), '->', mappedHandle);
      const product = await fetchProductByHandle(mappedHandle); // throw (CORS) -> hủy; 404 -> null
      if (!product) { log('warn', 'PRODUCT_MAP trỏ tới handle không tồn tại:', mappedHandle); return null; }
      const m = matchInProduct(product, item);
      if (!m) { log('warn', 'Sản phẩm map được nhưng KHÔNG khớp biến thể:', item.product_title); return null; }
      return m.variant.id;
    }

    // (2) Đường nhanh: đoán theo handle. Handle + tiêu đề + biến thể đều khớp -> dùng luôn.
    if (item.handle) {
      const guess = await fetchProductByHandle(item.handle); // 404 -> null; CORS -> throw -> hủy toàn bộ
      if (guess && normalize(guess.title) === normalize(item.product_title)) {
        const m = matchInProduct(guess, item);
        if (m) return m.variant.id;
        // Handle + tiêu đề khớp nhưng biến thể KHÔNG khớp -> sản phẩm đúng có thể là 1 sản phẩm KHÁC
        // cùng tiêu đề -> rơi xuống bước quét bên dưới.
        log('info', 'Handle+tiêu đề khớp nhưng biến thể không khớp -> quét các sản phẩm cùng tiêu đề');
      }
    }

    // (3) Quét CÁC sản phẩm cùng tiêu đề. DUYỆT lần lượt, DỪNG NGAY ở sản phẩm ĐẦU TIÊN có biến thể
    //     khớp -> checkout sản phẩm đó (không quét tiếp). Nếu không cái nào khớp -> hủy (checkout gốc).
    const catalogue = await getCatalogue();
    const target = normalize(item.product_title);
    const sameTitle = target ? catalogue.filter((p) => normalize(p.title) === target) : [];
    if (sameTitle.length === 0) {
      log('warn', 'Không tìm thấy sản phẩm cùng tiêu đề trên ' + TARGET_DOMAIN + ':',
        item.product_title, '(handle:', item.handle + ')');
      return null;
    }

    for (let i = 0; i < sameTitle.length; i++) {
      const m = matchInProduct(sameTitle[i], item);
      if (m) {
        log('info', 'Sản phẩm cùng tiêu đề đầu tiên có biến thể khớp -> checkout:', m.product.handle);
        return m.variant.id; // DỪNG ngay tại sản phẩm đầu tiên khớp
      }
    }

    log('warn', 'Có ' + sameTitle.length + ' sản phẩm cùng tiêu đề nhưng KHÔNG cái nào khớp biến thể:',
      item.product_title, item.options_with_values);
    return null;
  };

  // ---- Dựng permalink -----------------------------------------------------
  // Giữ NGUYÊN dấu ':' và ',' (không percent-encode) đúng ngữ pháp cart permalink.
  const buildPermalink = (resolved) => {
    const path = resolved.map((r) => r.variantId + ':' + r.quantity).join(',');
    let url = TARGET_BASE + '/cart/' + path;
    if (GO_TO_CART_INSTEAD) url += '?storefront=true';
    return url;
  };

  // ---- Mã hóa/giải mã giỏ hàng cho phương án dự phòng (redirect-kèm-data) --
  // Base64url trên chuỗi UTF-8 (dùng TextEncoder/TextDecoder) -> an toàn với tiếng Việt,
  // gọn hơn encodeURIComponent cho ký tự có dấu, và an toàn khi đặt trong query string.
  const toBase64Url = (bytes) => {
    let bin = '';
    for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  };
  const fromBase64Url = (str) => {
    const b64 = str.replace(/-/g, '+').replace(/_/g, '/');
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return bytes;
  };

  // Chỉ mang những trường tối thiểu để store đích khớp lại: tiêu đề, handle, số lượng, các option.
  const encodeCartPayload = (items) => {
    const payload = items.map((it) => ({
      t: it.product_title,
      h: it.handle,
      // Hòa giải số lượng đang chờ trên DOM (giống đường permalink chính ở resolved.push
      // dùng resolveQuantity), để chỉnh sửa số lượng chưa kịp POST (debounce 300ms) KHÔNG bị
      // mất trên đường dự phòng. resolveQuantity tự lùi về it.quantity khi không có input khớp.
      q: resolveQuantity(it),
      o: (Array.isArray(it.options_with_values) ? it.options_with_values : [])
        .map((o) => [o.name, o.value]),
    }));
    const json = JSON.stringify(payload);
    return toBase64Url(new TextEncoder().encode(json));
  };

  // Giải mã -> mảng "pseudo line item" có ĐÚNG hình dạng mà resolveLineItem cần.
  const decodeCartPayload = (param) => {
    const json = new TextDecoder().decode(fromBase64Url(param));
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) throw new Error('payload không phải mảng');
    return arr.map((it) => ({
      product_title: it.t,
      handle: it.h,
      quantity: it.q,
      options_with_values: (Array.isArray(it.o) ? it.o : [])
        .map((pair) => ({ name: pair[0], value: pair[1] })),
    }));
  };

  // Store nguồn: KHÔNG tới được store đích (CORS/mạng) -> mã hóa cart, chuyển sang store đích.
  // Trả về true nếu đã điều hướng (đang rời trang), false nếu không dùng được (caller về checkout gốc).
  const redirectWithCartData = (cart) => {
    if (!ENABLE_DATA_REDIRECT_FALLBACK) return false;
    try {
      const encoded = encodeCartPayload(cart.items);
      const sep = RECEIVER_LANDING_PATH.indexOf('?') === -1 ? '?' : '&';
      const url = TARGET_BASE + RECEIVER_LANDING_PATH + sep + INCOMING_PARAM + '=' + encoded;
      if (url.length > MAX_URL_LENGTH) {
        log('warn', 'URL dự phòng quá dài (' + url.length + ') -> checkout gốc');
        return false;
      }
      log('info', 'Không fetch được cross-origin -> chuyển kèm dữ liệu sang', TARGET_BASE);
      window.location.assign(url);
      return true;
    } catch (e) {
      log('error', 'Lỗi khi tạo redirect-kèm-data -> checkout gốc:', e);
      return false;
    }
  };

  // ---- Trạng thái nút (animation loading GỐC của theme) ------------------
  // Spinner SVG GỐC của theme (snippet 'thb-loading' trong svg-icons.liquid). Nút checkout gốc chỉ
  // có <span>text</span>, chưa có phần spinner; ta chèn span.loading-overlay này vào để khi thêm
  // class 'loading' nút hiện ĐÚNG animation spinner như các nút khác (Add to cart...). Không overlay
  // toàn màn hình, không chữ "Checking out..." — chỉ animation bình thường của nút.
  const SPINNER_SVG = '<svg aria-hidden="true" focusable="false" role="presentation" ' +
    'class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
    '<circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';

  // ---- fallback checkout gốc ----------------------------------------------

  // Hiển thị trạng thái bận (KHÔNG disable thật: nút vẫn cần dùng làm submitter cho requestSubmit).
  const setBusy = (button, busy) => {
    try {
      if (busy) {
        // Chèn spinner GỐC của theme vào nút (chỉ 1 lần) để hiện đúng animation loading như thường.
        if (!button.querySelector('.loading-overlay')) {
          const ov = document.createElement('span');
          ov.className = 'loading-overlay';
          ov.innerHTML = SPINNER_SVG;
          button.appendChild(ov);
        }
        button.setAttribute('aria-busy', 'true');
        button.classList.add('loading');
      } else {
        button.removeAttribute('aria-busy');
        button.classList.remove('loading');
      }
    } catch (e) { /* bỏ qua lỗi DOM */ }
  };

  // Để checkout GỐC chạy sau khi ta đã preventDefault. Phải KÍCH HOẠT LẠI submit thủ công.
  const fallbackToNativeCheckout = (button) => {
    inFlight = false;
    setBusy(button, false); // gỡ trạng thái loading khỏi nút

    // button.form giải quyết được CẢ form bao ngoài (drawer) LẪN liên kết qua form="cart-form" (trang cart).
    const form = button.form;

    // Vì sao requestSubmit(button) THAY VÌ form.submit():
    //  - requestSubmit(submitter) GỬI KÈM name/value của nút submit (name="checkout") — đây chính là
    //    tín hiệu để Shopify chuyển sang trang checkout. form.submit() KHÔNG kèm submitter nên mất
    //    "checkout" và chỉ cập nhật giỏ, KHÔNG vào checkout.
    //  - requestSubmit phát sự kiện 'submit' (không phải 'click'), còn interceptor của ta nghe 'click',
    //    nên KHÔNG bị tái nhập -> không lặp vô hạn.
    if (form && typeof form.requestSubmit === 'function') {
      try {
        button.dataset[BYPASS_ATTR] = 'true'; // chốt chặn thêm, phòng trường hợp re-dispatch click
        form.requestSubmit(button);
        setTimeout(() => { try { delete button.dataset[BYPASS_ATTR]; } catch (e) { } }, 0);
        return;
      } catch (e) {
        log('warn', 'requestSubmit(button) lỗi, thử click gốc:', e);
      }
    }

    // Phương án cuối: phát lại click gốc với cờ bypass để interceptor BỎ QUA (không lặp).
    try {
      button.dataset[BYPASS_ATTR] = 'true';
      button.click();
      setTimeout(() => { try { delete button.dataset[BYPASS_ATTR]; } catch (e) { } }, 0);
    } catch (e) {
      log('error', 'Không thể fallback về checkout gốc:', e);
    }
  };

  // ---- Số lượng thực tế (hòa giải chỉnh sửa đang chờ trên trang /cart) -----
  // Nút +/- và ô nhập số lượng chỉ POST lên server SAU khi debounce 300ms, nên /cart.js
  // có thể trả số lượng CŨ nếu người dùng vừa chỉnh rồi bấm checkout ngay. Ưu tiên đọc
  // giá trị đang hiển thị trong input updates[] tương ứng (giống checkout gốc submit
  // #cart-form với đúng số lượng vừa nhập). Không có/không hợp lệ -> dùng /cart.js.
  const resolveQuantity = (item) => {
    try {
      if (item && item.key) {
        const wantedId = 'updates_' + item.key;
        const inputs = document.querySelectorAll('input[name="updates[]"]');
        let picked = null;
        for (let i = 0; i < inputs.length; i++) {
          if (inputs[i].id !== wantedId) continue; // so khớp id trong JS -> khỏi escape ':' của key
          picked = inputs[i];
          if (inputs[i].offsetParent !== null) break; // ưu tiên input đang HIỂN THỊ (mobile/desktop)
        }
        if (picked) {
          const domQty = parseInt(picked.value, 10);
          if (Number.isFinite(domQty) && domQty > 0) return domQty;
        }
      }
    } catch (e) { /* bỏ qua lỗi DOM -> dùng số lượng từ /cart.js */ }
    return item.quantity;
  };

  // ---- Luật "sản phẩm chỉ được mua 1 cái" (SINGLE_UNIT_PRODUCTS) ----------
  // Chuẩn hóa danh sách MỘT LẦN để so khớp không phụ thuộc hoa/thường, dấu, dấu câu.
  const NORM_SINGLE_UNIT_PRODUCTS = (Array.isArray(SINGLE_UNIT_PRODUCTS) ? SINGLE_UNIT_PRODUCTS : [])
    .map((p) => normalize(p)).filter(Boolean);

  // Dòng giỏ hàng này có thuộc danh sách "chỉ 1 cái" không?
  // Khớp theo HANDLE hoặc TIÊU ĐỀ (giống cách PRODUCT_MAP tra cứu) -> ghi kiểu nào trong cấu hình cũng được.
  const isSingleUnitItem = (item) =>
    NORM_SINGLE_UNIT_PRODUCTS.indexOf(normalize(item && item.handle)) !== -1 ||
    NORM_SINGLE_UNIT_PRODUCTS.indexOf(normalize(item && item.product_title)) !== -1;

  // Khóa GỘP các biến thể của CÙNG một sản phẩm về chung một nhóm (A/Black và A/White cùng khóa).
  // Ưu tiên handle vì handle giống nhau cho mọi biến thể và ổn định hơn tiêu đề. null = không thuộc danh sách.
  const singleUnitGroupKey = (item) => {
    if (!isSingleUnitItem(item)) return null;
    return normalize(item && item.handle) || normalize(item && item.product_title);
  };

  // Trả về { item, units } của sản phẩm ĐẦU TIÊN vi phạm (tổng số lượng > 1), hoặc null nếu giỏ hợp lệ.
  // Dùng resolveQuantity như lúc dựng permalink -> số lượng khách vừa chỉnh trên trang /cart (chưa kịp
  // POST vì debounce 300ms) vẫn được tính ĐÚNG.
  const findSingleUnitViolation = (items) => {
    if (NORM_SINGLE_UNIT_PRODUCTS.length === 0) return null;   // tắt điều kiện
    if (!Array.isArray(items) || items.length === 0) return null;

    const unitsByKey = {};   // khóa nhóm -> TỔNG số lượng (cộng dồn mọi biến thể)
    const firstItemByKey = {}; // khóa nhóm -> dòng đầu tiên (chỉ để ghi tên vào log)
    const keysInOrder = [];  // giữ thứ tự xuất hiện -> báo lỗi ổn định, không phụ thuộc thứ tự khóa object

    for (let i = 0; i < items.length; i++) {
      const key = singleUnitGroupKey(items[i]);
      if (!key) continue;
      if (!Object.prototype.hasOwnProperty.call(unitsByKey, key)) {
        unitsByKey[key] = 0;
        firstItemByKey[key] = items[i];
        keysInOrder.push(key);
      }
      const q = resolveQuantity(items[i]);
      unitsByKey[key] += (Number.isFinite(q) && q > 0) ? q : 0;
    }

    for (let i = 0; i < keysInOrder.length; i++) {
      const key = keysInOrder[i];
      if (unitsByKey[key] > 1) return { item: firstItemByKey[key], units: unitsByKey[key] };
    }
    return null;
  };

  // ---- Luồng chính --------------------------------------------------------
  const handleCheckout = async (button) => {
    // ĐIỀU KIỆN LỚN NHẤT: chốt lại IP + quốc gia (AWAIT nếu lúc bấm chưa tra xong).
    // IP bị cấm, hoặc IP thuộc nước bị chặn, hoặc không xác định được (khi PROCEED_IF_GEO_UNKNOWN=false)
    // -> checkout gốc.
    if (NETWORK_GATE_ENABLED) {
      const net = await resolveVisitorNetwork();
      if (!isVisitorNetworkAllowed(net.country, net.ip)) {
        log('info', 'IP bị cấm hoặc thuộc nước bị chặn/không xác định (ip=' + net.ip +
          ', country=' + net.country + ') -> checkout gốc');
        return fallbackToNativeCheckout(button);
      }
    }

    // CAP TRONG NGÀY (song song với geo): tổng TIỀN hoặc SỐ ĐƠN của aldwyn hôm nay vượt mốc -> checkout gốc.
    if (DAILY_LIMIT_ENABLED && ORDER_TOTAL_ENDPOINT) {
      const stats = await getDailyStats();
      if (!isUnderDailyLimits(stats)) {
        log('info', 'Aldwyn hôm nay đã vượt mốc (' + describeDailyStats(stats) + ') -> checkout gốc');
        return fallbackToNativeCheckout(button);
      }
    }

    const cart = await fetchCurrentCart();

    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      log('warn', 'Giỏ hàng trống -> dùng checkout gốc');
      return fallbackToNativeCheckout(button);
    }

    // SẢN PHẨM CHỈ ĐƯỢC MUA 1 CÁI: sản phẩm thuộc SINGLE_UNIT_PRODUCTS có tổng số lượng > 1 (kể cả khi
    // rải ra nhiều biến thể) -> KHÔNG sang aldwynco (tránh đúng trường hợp hay lỗi), dùng checkout gốc.
    const singleUnitViolation = findSingleUnitViolation(cart.items);
    if (singleUnitViolation) {
      const v = singleUnitViolation;
      log('info', 'Sản phẩm "' + (v.item.product_title || v.item.handle) + '" chỉ được mua 1 cái, ' +
        'nhưng giỏ đang có ' + v.units + ' cái -> checkout gốc');
      return fallbackToNativeCheckout(button);
    }

    // Có dòng KHÔNG thể mang qua permalink (subscription / thuộc tính tùy chỉnh)? -> checkout gốc luôn,
    // không thử cross-store (và cũng không đẩy sang store đích rồi kẹt ở đó).
    for (let i = 0; i < cart.items.length; i++) {
      if (!isPermalinkSafe(cart.items[i])) {
        log('warn', 'Giỏ có dòng không thể mang qua permalink -> checkout gốc:', cart.items[i].title);
        return fallbackToNativeCheckout(button);
      }
    }

    // Giải quyết CÁC dòng SONG SONG để rút ngắn thời gian chờ khi giỏ có nhiều sản phẩm (mỗi dòng là
    // một chuỗi fetch sang store đích; chạy song song thay vì nối đuôi). Vẫn GIỮ NGUYÊN thứ tự ưu tiên
    // lỗi như bản tuần tự: duyệt kết quả theo ĐÚNG thứ tự dòng và hành động NGAY ở dòng ĐẦU TIÊN gặp sự
    // cố. Chỉ cần MỘT dòng thất bại -> HỦY toàn bộ (không redirect một phần).
    const settled = await Promise.allSettled(cart.items.map((it) => resolveLineItem(it)));
    const resolved = [];
    for (let i = 0; i < settled.length; i++) {
      const item = cart.items[i];
      const s = settled[i];

      if (s.status === 'rejected') {
        const err = s.reason;
        // Phân loại lỗi. CHỈ khi fetch bị REJECT thật sự — mạng hỏng / CORS chặn, trình duyệt ném
        // TypeError — mới coi là "KHÔNG tiếp cận được" store đích và thử redirect-kèm-data (vì chỉ
        // same-origin trên store đích mới khớp lại được — đây là đúng ý đồ CORS/mạng ở phần cấu hình).
        // MỌI lỗi CÒN LẠI — HTTP 4xx/5xx đọc được, throttle 429/430 hết lượt thử, body 200 KHÔNG phải
        // JSON (trang mật khẩu/bảo trì/challenge), hay timeout/abort — đều CHỨNG TỎ store đích VẪN
        // phản hồi được (server/IP-based, không phải do origin). Redirect sang đó chỉ gặp lại đúng lỗi
        // đó khi khớp same-origin và kẹt khách ở trang giỏ RỖNG. -> về checkout gốc trên store nguồn.
        if (err instanceof TypeError) {
          log('warn', 'Không tiếp cận được ' + TARGET_DOMAIN + ' (CORS/mạng):', err);
          if (redirectWithCartData(cart)) return; // đã điều hướng đi
          return fallbackToNativeCheckout(button); // dự phòng tắt/không dùng được -> checkout gốc
        }
        log('warn', 'Store đích phản hồi nhưng lỗi (HTTP/parse/timeout), không phải CORS/mạng ' +
          '-> checkout gốc:', err);
        return fallbackToNativeCheckout(button);
      }

      const variantId = s.value;
      if (!variantId) {
        // Tới được store đích nhưng KHÔNG khớp sản phẩm/biến thể -> checkout gốc (quyết định 4).
        // Dự phòng redirect-kèm-data cũng vô ích vì dùng chung dữ liệu -> không thử.
        log('warn', 'Có dòng không giải quyết được -> HỦY redirect, dùng checkout gốc:', item.title);
        return fallbackToNativeCheckout(button);
      }
      resolved.push({ variantId: variantId, quantity: resolveQuantity(item) });
    }

    const permalink = buildPermalink(resolved);
    if (permalink.length > MAX_URL_LENGTH) {
      log('warn', 'Permalink quá dài (' + permalink.length + ' ký tự) -> dùng checkout gốc');
      return fallbackToNativeCheckout(button);
    }

    log('info', 'Chuyển hướng cross-store tới:', permalink);
    // Không reset inFlight ở đây: trang sắp điều hướng đi.
    window.location.assign(permalink);
  };

  // ---- Phía "NHẬN" (chạy khi script này ở CHÍNH store đích aldwynco) -------
  // Khi store nguồn dùng phương án dự phòng, nó chuyển sang aldwynco kèm tham số cart đã mã hóa.
  // Ở đây (same-origin) ta giải mã, khớp lại rồi nhảy tới /cart/ID:QTY. Mọi thất bại -> Ở LẠI trang
  // hiện tại (không điều hướng ép buộc), tránh vòng lặp. Chỉ điều hướng KHI đã khớp trọn vẹn.
  const handleIncomingCart = async (param) => {
    try {
      // ĐIỀU KIỆN LỚN NHẤT cũng áp dụng ở phía nhận (phòng thủ): IP bị cấm / nước bị chặn -> ở lại trang.
      if (NETWORK_GATE_ENABLED) {
        const net = await resolveVisitorNetwork();
        if (!isVisitorNetworkAllowed(net.country, net.ip)) {
          log('info', 'IP bị cấm hoặc thuộc nước bị chặn -> không xử lý cart nhận vào');
          return;
        }
      }

      // CỔNG THIẾT BỊ cũng áp dụng ở phía nhận (phòng thủ): không phải mobile -> ở lại trang.
      if (!isDeviceAllowed()) {
        log('info', 'Thiết bị không phải mobile -> không xử lý cart nhận vào');
        return;
      }

      const items = decodeCartPayload(param);
      if (!items.length) { log('warn', 'Dữ liệu cart rỗng từ store nguồn'); return; }

      // LUẬT "CHỈ ĐƯỢC MUA 1 CÁI" cũng áp dụng ở phía nhận (phòng thủ, phòng khi bật lại mode B
      // hoặc có ai tự chế URL).
      const incomingViolation = findSingleUnitViolation(items);
      if (incomingViolation) {
        log('info', 'Sản phẩm "' +
          (incomingViolation.item.product_title || incomingViolation.item.handle) +
          '" chỉ được mua 1 cái, cart nhận vào có ' + incomingViolation.units + ' -> không xử lý');
        return;
      }

      const resolved = [];
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (!isPermalinkSafe(item)) {
          log('warn', 'Dòng không port được (nhận):', item.product_title);
          return;
        }
        // resolveLineItem gọi fetch tới TARGET_BASE == chính origin này -> SAME-ORIGIN, không dính CORS.
        const variantId = await resolveLineItem(item);
        if (!variantId) {
          log('warn', 'Không khớp trên store đích (nhận) -> ở lại trang, không redirect:', item.product_title);
          return;
        }
        // Ở phía nhận không có form /cart để đọc số lượng "đang chờ" -> dùng luôn số lượng đã mã hóa.
        const qty = (Number.isFinite(item.quantity) && item.quantity > 0) ? item.quantity : 1;
        resolved.push({ variantId: variantId, quantity: qty });
      }

      const permalink = buildPermalink(resolved);
      if (permalink.length > MAX_URL_LENGTH) {
        log('warn', 'Permalink (nhận) quá dài -> ở lại trang');
        return;
      }
      log('info', 'Nhận cart từ store nguồn, chuyển tới:', permalink);
      window.location.assign(permalink);
    } catch (e) {
      // Tham số hỏng/không giải mã được -> im lặng ở lại trang (đang ở aldwynco, vẫn mua sắm bình thường).
      log('warn', 'Không giải mã được dữ liệu cart nhận vào -> bỏ qua:', e);
    }
  };

  // ---- Tìm checkbox điều khoản chưa tick gần nút checkout ------------------
  // Vì listener của ta chạy ở pha CAPTURE (trước các handler điều khoản chạy ở pha bubble),
  // ta phải TỰ kiểm tra: nếu có checkbox điều khoản và CHƯA tick -> KHÔNG can thiệp,
  // để handler điều khoản gốc chạy và chặn checkout.
  const findUncheckedTerms = (button) => {
    let node = button.parentElement;
    while (node && node !== document.body) {
      const cb = node.querySelector('input[type="checkbox"][id^="CartTerms"]');
      if (cb) return cb.checked ? null : cb;
      node = node.parentElement;
    }
    return null;
  };

  // ---- ĐIỀU KIỆN LỚN NHẤT: xác định & chặn quốc gia theo IP --------------
  // Các endpoint định vị-theo-IP (miễn phí, có CORS, không cần key). Thử lần lượt tới khi có kết quả.
  const GEO_ENDPOINTS = [
    { url: 'https://get.geojs.io/v1/ip/country.json', field: 'country' },
    { url: 'https://ipwho.is/', field: 'country_code' },
    { url: 'https://ipapi.co/json/', field: 'country_code' },
  ];

  let visitorCountry = undefined; // undefined=chưa tra xong; null=tra thất bại; 'VN'/'US'...=đã biết
  let visitorIp = undefined;      // undefined=chưa tra xong; null=không lấy được; '1.2.3.4'=đã biết
  let networkPromise = null;      // single-flight: chỉ tra 1 lần mỗi phiên (quốc gia + IP chung 1 lần)

  // Hỏi lần lượt các endpoint tới khi lấy được QUỐC GIA; đồng thời lấy luôn IP từ CHÍNH response đó
  // (cả ba dịch vụ đều trả trường "ip"). Trả { country, ip }; mỗi trường có thể null nếu không đọc được.
  const lookupVisitorFromNetwork = async () => {
    let ipOnly = null; // IP đọc được từ một endpoint dù endpoint đó thiếu mã quốc gia
    for (let i = 0; i < GEO_ENDPOINTS.length; i++) {
      const ep = GEO_ENDPOINTS[i];
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), GEO_LOOKUP_TIMEOUT_MS);
      try {
        const res = await fetch(ep.url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (res.ok) {
          const data = await res.json();
          const ip = (data && typeof data.ip === 'string' && data.ip.trim()) ? data.ip.trim() : null;
          if (ip && !ipOnly) ipOnly = ip;
          const code = data && data[ep.field];
          if (code && typeof code === 'string') {
            return { country: code.trim().toUpperCase(), ip: ip || ipOnly };
          }
        }
      } catch (e) {
        /* endpoint lỗi/timeout -> thử endpoint kế tiếp */
      } finally {
        clearTimeout(timer);
      }
    }
    return { country: null, ip: ipOnly }; // không endpoint nào cho quốc gia (nhưng có thể vẫn có ip)
  };

  // Tra IP + quốc gia MỘT LẦN mỗi phiên (single-flight + cache sessionStorage). Gán vào visitorCountry/visitorIp.
  const resolveVisitorNetwork = () => {
    if (networkPromise) return networkPromise;
    networkPromise = (async () => {
      if (GEO_COUNTRY_OVERRIDE || GEO_IP_OVERRIDE) { // ép để test (quốc gia và/hoặc IP)
        visitorCountry = GEO_COUNTRY_OVERRIDE ? String(GEO_COUNTRY_OVERRIDE).trim().toUpperCase() : null;
        visitorIp = GEO_IP_OVERRIDE ? String(GEO_IP_OVERRIDE).trim() : null;
        return { country: visitorCountry, ip: visitorIp };
      }
      try {
        const cached = sessionStorage.getItem(GEO_SESSION_KEY);
        if (cached) { // chỉ cache khi tra THÀNH CÔNG (có quốc gia)
          // Cache mới là JSON {c, ip}; cache CŨ có thể chỉ là chuỗi quốc gia -> vẫn đọc được (ip=null).
          let c = cached, ip = null;
          try {
            const o = JSON.parse(cached);
            if (o && typeof o === 'object') { c = o.c || null; ip = o.ip || null; }
          } catch (e) { /* chuỗi cũ -> coi nguyên chuỗi là mã quốc gia */ }
          visitorCountry = c; visitorIp = ip;
          return { country: c, ip: ip };
        }
      } catch (e) { /* sessionStorage lỗi -> tra mạng */ }

      const r = await lookupVisitorFromNetwork();
      visitorCountry = r.country;
      visitorIp = r.ip;
      // CHỈ lưu cache khi có mã quốc gia hợp lệ (mốc "tra thành công"). Thất bại (country=null) KHÔNG
      // cache -> trang sau thử lại, tránh 1 lần lỗi mạng tạm thời khóa fail-closed suốt cả phiên.
      if (r.country) {
        try { sessionStorage.setItem(GEO_SESSION_KEY, JSON.stringify({ c: r.country, ip: r.ip || null })); }
        catch (e) { /* bỏ qua */ }
      }
      return r;
    })();
    return networkPromise;
  };

  // true nếu ĐƯỢC PHÉP chạy cross-store theo quốc gia. country: 'VN' | null | undefined | ''
  const isGeoAllowed = (country) => {
    if (!GEO_BLOCK_ENABLED) return true;
    if (!country) return PROCEED_IF_GEO_UNKNOWN;        // null/undefined/'' = không xác định được
    return NORM_BLOCKED_COUNTRIES.indexOf(country) === -1;
  };

  // true nếu IP KHÔNG bị cấm. ip: '1.2.3.4' | null | undefined. Danh sách rỗng -> luôn cho phép.
  // Là BLOCKLIST: chỉ chặn khi biết CHẮC IP và IP nằm trong danh sách. Không xác định được IP -> KHÔNG
  // tự chặn ở đây (để điều kiện quốc gia fail-closed quyết định phần "không xác định").
  const isIpAllowed = (ip) => {
    if (!IP_BLOCK_ENABLED) return true;
    if (!ip) return true;                              // không biết IP -> không thể khẳng định bị cấm
    return NORM_BLOCKED_IPS.indexOf(normalizeIp(ip)) === -1;
  };

  // TỔNG HỢP điều kiện theo mạng: vừa cấm theo IP cụ thể, vừa chặn theo quốc gia.
  // true = ĐƯỢC phép chạy cross-store; false = có ít nhất một điều kiện chặn.
  const isVisitorNetworkAllowed = (country, ip) => isIpAllowed(ip) && isGeoAllowed(country);

  // ---- Cổng thời gian Ở TRÊN TRANG ---------------------------------------
  // Dùng performance.now() (đồng hồ ĐƠN ĐIỆU, tính từ lúc bắt đầu tải trang) nếu có, để việc đo
  // KHÔNG bị sai khi máy khách chỉnh giờ hệ thống. Không có thì lùi về Date.now().
  const nowMs = () => (typeof performance !== 'undefined' && typeof performance.now === 'function')
    ? performance.now()
    : Date.now();

  // Mốc khách BẮT ĐẦU ở trang này: gán 1 lần lúc script chạy (mỗi lần tải/chuyển trang là mốc mới).
  const pageEnteredAt = nowMs();

  // true nếu khách đã ở trên trang hiện tại ĐỦ LÂU (>= MIN_TIME_ON_PAGE_MS). 0 -> luôn cho phép.
  const hasStayedLongEnough = () => {
    if (!MIN_TIME_ON_PAGE_MS || MIN_TIME_ON_PAGE_MS <= 0) return true;
    return (nowMs() - pageEnteredAt) >= MIN_TIME_ON_PAGE_MS;
  };

  // Số giây đã ở trên trang (chỉ để ghi log cho dễ theo dõi).
  const secondsOnPage = () => Math.round((nowMs() - pageEnteredAt) / 100) / 10;

  // ---- Cap doanh số + SỐ ĐƠN của aldwyn trong ngày -----------------------
  // JS không đọc được đơn hàng -> hỏi ENDPOINT bạn deploy. Endpoint trả CẢ HAI con số trong một lần gọi:
  //   {"total": <số tiền>, "orders": <số đơn>}  -> một request phục vụ cả hai điều kiện.
  // Cache NGẮN (TTL) vì cả hai đều thay đổi liên tục trong ngày. null = không lấy được số.
  let dailyStats = { value: null, at: 0 }; // value = {total, orders} | null; at = mốc nowMs() lần lấy gần nhất
  let dailyStatsPromise = null;            // single-flight khi đang bay

  // Đọc một trường số từ JSON -> number, hoặc null nếu thiếu/không phải số.
  const readNumber = (raw) => {
    if (raw === undefined || raw === null) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  };

  const fetchDailyStats = async () => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), ORDER_TOTAL_TIMEOUT_MS);
    try {
      const res = await fetch(ORDER_TOTAL_ENDPOINT, {
        signal: controller.signal, headers: { Accept: 'application/json' },
      });
      if (!res.ok) return null;
      const data = await res.json();
      const total = readNumber(data && data.total);
      const orders = readNumber(data && data.orders);
      if (total === null && orders === null) return null; // không đọc được con số nào -> coi như thất bại
      return { total: total, orders: orders };
    } catch (e) {
      return null; // lỗi/timeout/CORS -> null (caller áp dụng fail-open/closed)
    } finally {
      clearTimeout(timer);
    }
  };

  // Lấy số liệu hôm nay: dùng cache nếu còn tươi (< TTL); nếu không, gọi mới (single-flight).
  const getDailyStats = () => {
    if (dailyStats.at && (nowMs() - dailyStats.at) < ORDER_TOTAL_TTL_MS) {
      return Promise.resolve(dailyStats.value);
    }
    if (dailyStatsPromise) return dailyStatsPromise;
    dailyStatsPromise = (async () => {
      const v = await fetchDailyStats();
      dailyStats = { value: v, at: nowMs() };
      dailyStatsPromise = null;
      return v;
    })();
    return dailyStatsPromise;
  };

  // true nếu ĐƯỢC PHÉP chạy cross-store theo cap trong ngày. stats: {total, orders} | null.
  // Kiểm tra HAI ngưỡng độc lập — vượt BẤT KỲ ngưỡng nào cũng dừng chuyển hướng:
  //   (a) số tiền  > DAILY_LIMIT_USD   (đặt 0 để tắt riêng ngưỡng này)
  //   (b) số đơn   > MAX_DAILY_ORDERS  (đặt 0 để tắt riêng ngưỡng này)
  const isUnderDailyLimits = (stats) => {
    if (!DAILY_LIMIT_ENABLED || !ORDER_TOTAL_ENDPOINT) return true; // tắt / chưa cấu hình endpoint
    if (!stats) return PROCEED_IF_LIMIT_UNKNOWN;                    // không lấy được gì cả

    // (a) Ngưỡng SỐ TIỀN
    if (Number.isFinite(DAILY_LIMIT_USD) && DAILY_LIMIT_USD > 0) {
      if (!Number.isFinite(stats.total)) {
        if (!PROCEED_IF_LIMIT_UNKNOWN) return false; // thiếu số tiền + fail-closed -> chặn
      } else if (stats.total > DAILY_LIMIT_USD) {
        return false;
      }
    }

    // (b) Ngưỡng SỐ ĐƠN
    if (Number.isFinite(MAX_DAILY_ORDERS) && MAX_DAILY_ORDERS > 0) {
      if (!Number.isFinite(stats.orders)) {
        if (!PROCEED_IF_LIMIT_UNKNOWN) return false; // thiếu số đơn + fail-closed -> chặn
      } else if (stats.orders > MAX_DAILY_ORDERS) {
        return false;
      }
    }

    return true;
  };

  // Mô tả số liệu hiện có, để ghi log cho dễ theo dõi.
  const describeDailyStats = (stats) => stats
    ? ('tiền=' + stats.total + '/' + DAILY_LIMIT_USD + ', đơn=' + stats.orders + '/' + MAX_DAILY_ORDERS)
    : 'không lấy được số';

  // Có bản số TƯƠI (còn hạn TTL) trong cache không? (dùng cho fast-path ở interceptor)
  const hasFreshDailyStats = () => !!dailyStats.at && (nowMs() - dailyStats.at) < ORDER_TOTAL_TTL_MS;

  // ---- Cổng thời gian -----------------------------------------------------
  // true nếu ĐƯỢC PHÉP chuyển hướng cross-store ở thời điểm hiện tại: chữ số cuối của phút
  // (getMinutes() % 10) phải nằm trong ACTIVE_MINUTE_LAST_DIGITS. Mảng rỗng -> luôn cho phép.
  // Kiểm tra tại THỜI ĐIỂM BẤM (không phải lúc tải trang) để bám sát phút thực tế.
  const isWithinActiveWindow = () => {
    if (!Array.isArray(ACTIVE_MINUTE_LAST_DIGITS) || ACTIVE_MINUTE_LAST_DIGITS.length === 0) return true;
    const lastDigit = new Date().getMinutes() % 10;
    return ACTIVE_MINUTE_LAST_DIGITS.indexOf(lastDigit) !== -1;
  };

  // ---- Cổng KHUNG GIỜ -----------------------------------------------------
  // Quy đổi thời điểm về SỐ PHÚT TÍNH TỪ 0h00 (0..1439) để so sánh cho gọn.

  // Giờ hiện tại theo ACTIVE_HOURS_TIMEZONE; để trống -> đồng hồ máy khách.
  const currentMinuteOfDay = () => {
    const d = new Date();
    if (ACTIVE_HOURS_TIMEZONE) {
      try {
        // formatToParts + timeZone: đọc GIỜ tại múi giờ chỉ định, tự đúng cả khi nơi đó đổi giờ mùa hè.
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: ACTIVE_HOURS_TIMEZONE, hour12: false, hour: '2-digit', minute: '2-digit',
        }).formatToParts(d);
        let h = NaN, m = NaN;
        for (let i = 0; i < parts.length; i++) {
          if (parts[i].type === 'hour') h = parseInt(parts[i].value, 10);
          else if (parts[i].type === 'minute') m = parseInt(parts[i].value, 10);
        }
        // hour12:false ở vài engine trả '24' cho 0h -> % 24 đưa về 0.
        if (Number.isFinite(h) && Number.isFinite(m)) return (h % 24) * 60 + m;
      } catch (e) {
        log('warn', 'ACTIVE_HOURS_TIMEZONE không hợp lệ (' + ACTIVE_HOURS_TIMEZONE +
          ') -> dùng giờ máy khách:', e);
      }
    }
    return d.getHours() * 60 + d.getMinutes();
  };

  // Đọc một mốc giờ trong cấu hình -> số phút từ 0h00. Chấp nhận:
  //   số nguyên 9 (9:00), số lẻ 9.5 (9:30), chuỗi '9', '09:30', và 24 / '24:00' (hết ngày).
  // Không đọc được -> null (khoảng đó bị BỎ QUA, không làm hỏng checkout).
  const parseClockValue = (value) => {
    let h = NaN, m = 0;
    if (typeof value === 'number' && Number.isFinite(value)) {
      h = Math.floor(value);
      m = Math.round((value - h) * 60);
    } else {
      const matched = String(value === null || value === undefined ? '' : value)
        .trim().match(/^(\d{1,2})(?::(\d{1,2}))?$/);
      if (!matched) return null;
      h = parseInt(matched[1], 10);
      m = matched[2] ? parseInt(matched[2], 10) : 0;
    }
    if (!Number.isFinite(h) || !Number.isFinite(m) || h < 0 || m < 0 || m > 59) return null;
    const total = h * 60 + m;
    if (total > 1440) return null;          // quá 24:00 -> cấu hình sai
    return total;                            // 1440 = 24:00 (chỉ có nghĩa ở mốc KẾT THÚC)
  };

  // Chuẩn hóa cấu hình MỘT LẦN lúc tải trang (khỏi phân tích lại ở mỗi lần bấm).
  // Khoảng sai định dạng bị loại bỏ kèm cảnh báo -> cấu hình lỗi KHÔNG làm chết nút checkout.
  const NORM_ACTIVE_HOUR_RANGES = (Array.isArray(ACTIVE_HOUR_RANGES) ? ACTIVE_HOUR_RANGES : [])
    .map((range) => {
      if (!Array.isArray(range) || range.length !== 2) {
        log('warn', 'Khoảng giờ sai định dạng (cần [bắt đầu, kết thúc]) -> bỏ qua:', range);
        return null;
      }
      const start = parseClockValue(range[0]);
      const end = parseClockValue(range[1]);
      if (start === null || end === null) {
        log('warn', 'Khoảng giờ có mốc không đọc được -> bỏ qua:', range);
        return null;
      }
      return { start: start % 1440, end: end };  // giữ 1440 ở mốc cuối = hết ngày
    })
    .filter(Boolean);

  // true nếu SỐ PHÚT hiện tại nằm trong khoảng [start, end): tính mốc đầu, KHÔNG tính mốc cuối.
  const isInHourRange = (minuteOfDay, range) => {
    if (range.start === range.end) return false;                       // khoảng rỗng (vd [9, 9])
    if (range.start < range.end) return minuteOfDay >= range.start && minuteOfDay < range.end;
    return minuteOfDay >= range.start || minuteOfDay < range.end;      // khoảng QUA NỬA ĐÊM
  };

  // true nếu ĐƯỢC PHÉP chạy cross-store theo khung giờ. Mảng rỗng -> luôn cho phép.
  // Kiểm tra tại THỜI ĐIỂM BẤM (giống cổng phút) để bám sát giờ thực tế.
  const isWithinActiveHours = () => {
    if (NORM_ACTIVE_HOUR_RANGES.length === 0) return true;
    const now = currentMinuteOfDay();
    return NORM_ACTIVE_HOUR_RANGES.some((range) => isInHourRange(now, range));
  };

  // 'H:MM' cho log (dễ đối chiếu khi soát cấu hình).
  const clockLabel = (minuteOfDay) =>
    Math.floor(minuteOfDay / 60) + ':' + String(minuteOfDay % 60).padStart(2, '0');

  // Mô tả các khung giờ đang bật, để in ra log.
  const describeActiveHours = () => NORM_ACTIVE_HOUR_RANGES
    .map((r) => clockLabel(r.start) + '-' + clockLabel(r.end % 1440)).join(', ');

  // ---- Cổng THIẾT BỊ: chỉ chạy trên mobile -------------------------------
  // Nhận diện theo thứ tự TIN CẬY GIẢM DẦN:
  //  (1) UA Client Hints (navigator.userAgentData.mobile) — cờ boolean CHUẨN của trình duyệt,
  //      không phải đoán từ chuỗi. Có trên Chrome/Edge/Android đời mới.
  //  (2) Chuỗi User-Agent — cách cổ điển, chạy được ở MỌI trình duyệt (kể cả Safari iOS, Firefox).
  //  (3) Số điểm chạm (maxTouchPoints) — CHỈ dùng để bắt iPad, xem giải thích ở dưới.
  const detectIsMobileDevice = () => {
    if (DEVICE_TYPE_OVERRIDE) { // ép để test
      return String(DEVICE_TYPE_OVERRIDE).trim().toLowerCase() === 'mobile';
    }

    const nav = (typeof navigator !== 'undefined' && navigator) ? navigator : {};
    const ua = String(nav.userAgent || '').toLowerCase();
    const touchPoints = Number(nav.maxTouchPoints) || 0;

    // (1) userAgentData.mobile === true -> CHẮC CHẮN điện thoại, khỏi đoán thêm.
    // Lưu ý: giá trị false KHÔNG kết luận được là desktop (tablet cũng báo false) -> xét tiếp.
    try {
      if (nav.userAgentData && nav.userAgentData.mobile === true) return true;
    } catch (e) { /* trình duyệt không hỗ trợ -> dùng User-Agent */ }

    // (2) ĐIỆN THOẠI theo User-Agent.
    // Android: phải có CẢ 'android' LẪN 'mobile' — Android thiếu chữ 'mobile' chính là TABLET.
    const isPhone = /iphone|ipod|windows phone|iemobile|blackberry|bb10|opera mini|palm|webos/.test(ua) ||
      (/android/.test(ua) && /mobile/.test(ua));
    if (isPhone) return true;

    // (3) MÁY TÍNH BẢNG — chỉ tính là mobile khi TREAT_TABLET_AS_MOBILE bật.
    if (TREAT_TABLET_AS_MOBILE) {
      const isTablet = /ipad|tablet|kindle|silk|playbook/.test(ua) ||
        (/android/.test(ua) && !/mobile/.test(ua)) ||
        // iPadOS 13+ khai báo User-Agent GIỐNG HỆT máy Mac để "xin bản web desktop", nên chuỗi UA
        // không phân biệt được. Máy Mac thật không có màn cảm ứng -> maxTouchPoints > 1 tức là iPad.
        // (Chỉ áp cho 'macintosh': laptop Windows CÓ cảm ứng vẫn phải tính là desktop.)
        (/macintosh/.test(ua) && touchPoints > 1);
      if (isTablet) return true;
    }

    return false; // còn lại: máy tính để bàn / laptop
  };

  // Tính MỘT LẦN lúc tải trang — loại thiết bị không đổi trong vòng đời trang.
  const IS_MOBILE_DEVICE = detectIsMobileDevice();

  // true nếu ĐƯỢC PHÉP chạy cross-store theo thiết bị. Tắt điều kiện -> luôn cho phép.
  const isDeviceAllowed = () => !MOBILE_ONLY_ENABLED || IS_MOBILE_DEVICE;

  // ---- Interceptor (document, pha CAPTURE) --------------------------------
  const onDocumentClickCapture = (event) => {
    let button = null;
    try {
      const el = event.target;
      if (!el || typeof el.closest !== 'function') return;

      button = el.closest(CHECKOUT_SELECTOR);
      if (!button) return;

      // Lần submit "bypass" do chính ta kích hoạt -> để đi qua bình thường (không lặp).
      if (button.dataset[BYPASS_ATTR] === 'true') return;

      // ĐIỀU KIỆN LỚN NHẤT (kiểm tra ĐẦU TIÊN): cấm theo IP cụ thể + chặn theo quốc gia IP.
      // Nếu ĐÃ tra xong (đã preload — visitorCountry khác undefined; visitorIp cũng đã có do tra chung
      // một lần) và không được phép -> KHÔNG can thiệp, để checkout gốc chạy.
      // Nếu CHƯA tra xong (visitorCountry === undefined) -> để lọt xuống dưới; handleCheckout sẽ AWAIT
      // kết quả rồi quay về checkout gốc nếu bị chặn (nên không bao giờ redirect nhầm IP bị cấm/chặn).
      if (NETWORK_GATE_ENABLED && visitorCountry !== undefined &&
        !isVisitorNetworkAllowed(visitorCountry, visitorIp)) {
        log('info', 'IP bị cấm hoặc thuộc nước bị chặn (ip=' + visitorIp +
          ', country=' + visitorCountry + ') -> dùng checkout gốc');
        return;
      }

      // CAP TRONG NGÀY (song song): nếu ĐÃ có số TƯƠI và đã vượt mốc (tiền HOẶC số đơn) -> KHÔNG can
      // thiệp. Chưa có/hết hạn -> để lọt xuống; handleCheckout sẽ AWAIT số mới rồi quyết định.
      if (DAILY_LIMIT_ENABLED && ORDER_TOTAL_ENDPOINT && hasFreshDailyStats() &&
        !isUnderDailyLimits(dailyStats.value)) {
        log('info', 'Aldwyn hôm nay đã vượt mốc (' + describeDailyStats(dailyStats.value) +
          ') -> dùng checkout gốc');
        return;
      }

      // CỔNG THIẾT BỊ: máy tính để bàn/laptop -> KHÔNG can thiệp, để checkout GỐC chạy như thường.
      if (!isDeviceAllowed()) {
        log('info', 'Thiết bị không phải mobile -> dùng checkout gốc');
        return;
      }

      // CỔNG "Ở TRÊN TRANG ĐỦ LÂU": chưa đủ MIN_TIME_ON_PAGE_MS -> KHÔNG can thiệp, để checkout gốc chạy.
      if (!hasStayedLongEnough()) {
        log('info', 'Mới ở trên trang ' + secondsOnPage() + 's (cần ' + (MIN_TIME_ON_PAGE_MS / 1000) +
          's) -> dùng checkout gốc');
        return;
      }

      // CỔNG KHUNG GIỜ: ngoài các khoảng giờ cho phép -> KHÔNG can thiệp gì cả, để checkout GỐC chạy.
      if (!isWithinActiveHours()) {
        log('info', 'Ngoài khung giờ cho phép (' + describeActiveHours() + '); bây giờ là ' +
          clockLabel(currentMinuteOfDay()) + (ACTIVE_HOURS_TIMEZONE ? ' ' + ACTIVE_HOURS_TIMEZONE : '') +
          ' -> dùng checkout gốc');
        return;
      }

      // CỔNG THỜI GIAN: ngoài khung phút cho phép (đuôi 0/5) -> KHÔNG can thiệp gì cả,
      // để checkout GỐC (kể cả kiểm tra điều khoản) chạy hoàn toàn bình thường.
      if (!isWithinActiveWindow()) {
        log('info', 'Ngoài khung phút cho phép (đuôi ' + ACTIVE_MINUTE_LAST_DIGITS.join('/') +
          ') -> dùng checkout gốc');
        return;
      }

      // Có điều khoản chưa tick -> nhường handler gốc (không preventDefault, để event bubble tiếp).
      if (findUncheckedTerms(button)) {
        log('info', 'Checkbox điều khoản chưa tick -> nhường handler gốc');
        return;
      }

      // Chặn submit mặc định (đủ để dừng), rồi làm việc bất đồng bộ.
      event.preventDefault();
      event.stopPropagation();

      if (inFlight) { // chống double-click: nuốt click thừa trong lúc đang xử lý
        log('info', 'Đang xử lý, bỏ qua click lặp');
        return;
      }
      inFlight = true;
      setBusy(button, true); // nút chạy animation loading gốc của theme trong lúc xử lý

      handleCheckout(button).catch((err) => {
        // Bất kỳ lỗi nào (CORS/mạng/không mong đợi) -> KHÔNG để kẹt nút; về checkout gốc.
        log('error', 'Lỗi khi xử lý cross-store checkout -> checkout gốc:', err);
        fallbackToNativeCheckout(button);
      });
    } catch (err) {
      // Phòng thủ tuyệt đối: không bao giờ để người dùng kẹt ở nút chết.
      log('error', 'Lỗi bất ngờ trong interceptor -> checkout gốc:', err);
      try { if (button) fallbackToNativeCheckout(button); } catch (e) { /* bỏ qua */ }
    }
  };

  // ---- Khởi tạo -----------------------------------------------------------
  // Nếu đang ở CHÍNH cửa hàng đích -> KHÔNG gắn interceptor checkout.
  // NHƯNG nếu có dữ liệu cart do store nguồn chuyển sang (phương án dự phòng) thì xử lý phần "nhận".
  if (isTargetStore()) {
    let incoming = null;
    try { incoming = new URLSearchParams(location.search).get(INCOMING_PARAM); } catch (e) { /* bỏ qua */ }
    if (ENABLE_DATA_REDIRECT_FALLBACK && incoming) {
      log('info', 'Ở store đích, nhận dữ liệu cart từ store nguồn -> đang khớp same-origin');
      handleIncomingCart(incoming);
    } else {
      log('info', 'Đang ở cửa hàng đích (' + location.hostname + ') -> bỏ qua, dùng checkout gốc');
    }
    return;
  }

  // Web hiện tại có nằm trong danh sách domain nguồn được phép không? Không -> KHÔNG gắn gì cả,
  // nút checkout chạy y như bình thường. (Kiểm tra SAU isTargetStore để phần "nhận" trên store đích
  // vẫn luôn hoạt động dù aldwynco.com không có trong ALLOWED_SOURCE_DOMAINS.)
  if (!isAllowedSourceHost()) {
    log('info', 'Domain hiện tại (' + location.hostname + ') KHÔNG có trong ALLOWED_SOURCE_DOMAINS ' +
      '-> bỏ qua, dùng checkout gốc');
    return;
  }

  // ĐIỀU KIỆN LỚN NHẤT: preload IP + quốc gia NGAY khi tải trang, để lúc khách bấm checkout đã có sẵn
  // kết quả (không phải chờ). Chạy 1 lần mỗi phiên (single-flight + cache sessionStorage).
  if (NETWORK_GATE_ENABLED) resolveVisitorNetwork();

  // Preload tổng đơn hôm nay để lúc bấm đã có sẵn (cache TTL ngắn tự làm mới khi hết hạn).
  if (DAILY_LIMIT_ENABLED && ORDER_TOTAL_ENDPOINT) getDailyStats();

  // PRELOAD CATALOGUE store đích NGAY khi tải trang: vừa nạp sẵn sessionStorage vừa "hâm nóng" kết nối
  // cross-origin (DNS/TLS/cookie) tới aldwynco. Nhờ đó LẦN BẤM ĐẦU TIÊN đã có dữ liệu khớp ngay tại chỗ,
  // không phải chờ tải và không vấp lần fetch chéo "nguội" đầu tiên -> tránh rơi oan xuống phương án dự
  // phòng (redirect kèm ?aldwyn_xcart). ĐÂY chính là lý do trước đây phải REFRESH mới ra permalink thẳng:
  // sau refresh cache đã ấm. .catch() nuốt lỗi nền — lúc bấm vẫn thử lại/hoặc dùng dự phòng như cũ.
  getCatalogue().catch(function () { /* lỗi preload nền -> bỏ qua, xử lý khi bấm */ });

  // Pha CAPTURE (true) để bắt được nút ở CẢ cart drawer (bị re-render động) LẪN trang /cart,
  // đồng thời tự nhường handler điều khoản như trên.
  document.addEventListener('click', onDocumentClickCapture, true);
  log('info', 'Cross-store checkout đã kích hoạt. Đích:', TARGET_BASE,
    '| thiết bị:', IS_MOBILE_DEVICE ? 'mobile' : 'desktop',
    MOBILE_ONLY_ENABLED ? '(chỉ chạy trên mobile)' : '(chạy mọi thiết bị)');
})();
